import { z } from 'zod';
import { useSettingsStore } from '@/stores/SettingsStore.ts';

const StoreSyncSettingsValueSchema = z.object({
    lastSeenChangelogVersion: z.string().optional(),
    selectedProfileId: z.string().optional(),
    hotkeys: z.record(z.string()),
    loggingLevel: z.enum(['trace', 'debug', 'info', 'warn', 'error', 'fatal', 'silent']),
});

export const storeSyncSettingsHandler = (rawValue: object) => {
    const value = StoreSyncSettingsValueSchema.parse(rawValue);

    const settingsStore = useSettingsStore();
    settingsStore.$patch({
        lastSeenChangelogVersion: value.lastSeenChangelogVersion,
        selectedProfileId: value.selectedProfileId,
        hotkeys: value.hotkeys,
        loggingLevel: value.loggingLevel,
    });
};
